import { tableBodyStyle, tableHeaderStyle } from 'config/global';

// Updated column configuration for both tables to be consistent
export const recentMeetColumns = [
  {
    accessor: 'eventAndDate',
    label: 'Event & Date',
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
  {
    accessor: 'roundType',
    label: 'Round',
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
  {
    accessor: 'result',
    label: 'Result',
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
  {
    accessor: 'position',
    label: 'Position',
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
  {
    accessor: 'seasonPRValue',
    label: 'Season Best',
    checkbox: false,
    sortable: false,
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
  {
    accessor: 'pbValue',
    label: 'Personal Best',
    checkbox: false,
    sortable: false,
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
  {
    accessor: 'seasonHistory',
    label: 'Season History',
    checkbox: false,
    sortable: false,
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
];

export const pastMeetsColumns = [
  {
    accessor: 'eventAndDate',
    label: 'Event & Date',
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
  {
    accessor: 'roundType',
    label: 'Round',
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
  {
    accessor: 'result',
    label: 'Result',
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
  {
    accessor: 'position',
    label: 'Position',
    checkbox: false,
    sortable: false,
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
  {
    accessor: 'seasonPRValue',
    label: 'Season Best',
    checkbox: false,
    sortable: false,
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
  {
    accessor: 'pbValue',
    label: 'Personal Best',
    checkbox: false,
    sortable: false,
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
  {
    accessor: 'seasonHistory',
    label: 'Season History',
    checkbox: false,
    sortable: false,
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
];

export const historyResultDataColumns = [
  {
    accessor: 'date',
    label: 'Date',
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
  {
    accessor: 'result',
    label: 'Result',
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
  {
    accessor: 'position',
    label: 'Position',
    checkbox: false,
    sortable: false,
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
  {
    accessor: 'status',
    label: 'Status',
    headerStyle: tableHeaderStyle,
    style: tableBodyStyle,
  },
];
